import React, { useEffect, useState } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { CoachDetailsCertificates } from "../../../../stories/CoachDetailCertificates/CoachDetailsCertificates";
import { CoachDetailsTrainingLocations } from "../../../../stories/CoachDetailTrainingLocations/CoachDetailsTrainingLocations";
import { CommonQuestions } from "../../../../stories/CommonQuestions/CommonQuestions";
import { CoachDetailAboutMe } from "../../../../stories/CoachDetailAboutMe/CoachDetailAboutMe.jsx";
import classes from "./CoachDetailsPreviewProfile.module.css";
import { BookALessonCardWithGallery } from "../../../../stories/BookALessonCardWithGallery/BookALessonCardWithGallery";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { Tabs } from "../../../../stories/Tabs/Tabs";
import { Checkbox } from "../../../../stories/Checkbox/Checkbox";
import { Button } from "../../../../stories/Button/Button";
import { InfoIconGray } from "../../../../constant/imagePath";
import { isMobileViewHook } from "../../../../CustomHooks/isMobileViewHook";
import CoachDetailsPreviewProfileMobile from "./CoachDetailsPreviewProfileMobile";
import { useHistory } from "react-router-dom";
import CoachDetailsScheduleCard from "../../../../stories/CoachDetailsScheduleCard/CoachDetailsScheduleCard";
import scheduleCardClasses from '../../../../stories/CoachDetailsScheduleCard/CoachDetailsScheduleCard.module.css'

function CoachDetailsPreviewProfileDesktop() {
  const [selectTab, setSelectTab] = useState({ label: "About me" });
  const [confirmProfile, setConfirmProfile] = useState([]);

  const history = useHistory()
  return (
    <div className={classes.coachDetailsPreviewProfile}>
      <style jsx>{`
      @media screen and (max-width:1190px){
      .${scheduleCardClasses.card}{
            padding: 24px 18px 20px 18px;
        
      }
      .${scheduleCardClasses.card} .${scheduleCardClasses.time} button{
        font-size:12px !important;
        line-height:18px !important;
        
      }
      .${scheduleCardClasses.card} .${scheduleCardClasses.dayAndDate} p{
        font-size:12px !important;
        line-height:18px !important;
            }
      .${scheduleCardClasses.card} .${scheduleCardClasses.dayAndDate} h6{
        font-size:12px !important;
        line-height:18px !important;
            }
      .${scheduleCardClasses.card} .${scheduleCardClasses.continueBtn} button{
        height:46px !important;
        font-size:14px !important;

            }

    }
      @media screen and (max-width:1125px){
      .${scheduleCardClasses.card} .${scheduleCardClasses.time} button{
        font-size:10px !important;
        line-height:16px !important;
        padding:6px 0px !important;
        
      }
      .${scheduleCardClasses.card} .${scheduleCardClasses.dayAndDate} p{
        font-size:10px !important;
        line-height:16px !important;
            }
      .${scheduleCardClasses.card} .${scheduleCardClasses.dayAndDate} h6{
        font-size:10px !important;
        line-height:16px !important;
            }
      .${scheduleCardClasses.card} .${scheduleCardClasses.continueBtn} button{
        height:44px !important;
        font-size:13px !important;

            }

    }
      `}</style>
      {/* First Row */}
      <Row className={'gx-0'}>
        <Col md={12} style={{ background: Colors.neutralShadesOfWhiteSmoke }} className={classes.firstRowContainer} >
          <Col md={12}>
            <div className={classes.staticAlert}>
              <div className={classes.left}>
                <p style={{ ...Fonts.h9, color: Colors.neutralShadesOfNero }}>
                  Just one more thing!
                </p>
                <h4 style={{ ...Fonts.h4 }} className={classes.h4}>
                  Preview how your profile looks to students
                </h4>
                <Checkbox label="I confirm that my profile information is accurate" value={confirmProfile} setValue={setConfirmProfile} />
              </div>
              <div className={classes.right}>
                <div className={classes.alertWithIcon}>
                  <p
                    style={{
                      ...Fonts.p4,
                      color: Colors.neutralShadesOfDimGray,
                    }}
                  >
                    You can continue to edit your profile once your account is
                    established.
                  </p>
                  <img src={InfoIconGray} />
                </div>
                <div className={classes.btnsBox}>
                  <Button
                    primary={false}
                    label={"Back to Edit"}
                    size={'Medium'}
                    customStyle={{
                      padding: "14px 24px 14px 24px",
                      marginRight: "12px",
                    }}
                    onClick={() => history.push('/all-steps')}
                  />
                  <Button
                    primary={true}
                    label={"Finish"}
                    customStyle={{

                      width: "120px",
                    }}
                    disabled={confirmProfile?.length == 0 ? true : false}
                    onClick={() => history.push('/todo')}
                  />
                </div>
              </div>
            </div>
          </Col>
          <Col md={12} xl={12} lg={12}>
            <div className={classes.galleryWithTabs}>
              <BookALessonCardWithGallery />
            </div>
          </Col>
          <Col md={10} xl={6} lg={7} xxl={7}>
            <h4 style={{ ...Fonts.h4, color: Colors.neutralShadesOfNero, fontSize: '26px' }} className={classes.h4}>
              More about coach Micahel
            </h4>
            <Tabs
              tabsData={[
                { label: "About me" },
                {
                  label: "Credentials and Experience",
                },
                { label: "Session plan" },
              ]}
              state={selectTab}
              setState={setSelectTab}
            />
          </Col>
        </Col>
        <Col md={10} xl={6} lg={7} xxl={7} className={`${[classes.mb80, classes.firstRowContainer].join(" ")}`} style={{ paddingRight: '0px' }}>
          <CoachDetailAboutMe />
        </Col>
        <Col md={12} xl={6} lg={5} xxl={5} className={`${[classes.mb80, classes.firstRowContainer].join(" ")}`}>
          <div className={classes.scheduleCard}>
            <CoachDetailsScheduleCard />
          </div>
        </Col>

      </Row>
      {/* Second Row */}
      <Row className={`gx-0 ${[classes.secondRow].join(" ")}`}>

        <Col md={10} xl={6} lg={8} className={classes.mb80}>
          <CoachDetailsCertificates />
        </Col>
        <Col xl={6} lg={4} md={2} />
        <Col md={10} xl={6} lg={8} className={classes.mb80}>
          <CoachDetailsTrainingLocations />
        </Col>
        <Col xl={6} lg={4} md={2} />
        <Col md={10} xl={6} lg={8} className={classes.mb80}>
          <CommonQuestions heading="Common Questions" />
        </Col>
      </Row>
    </div>
  );
}

export default function CoachDetailsPreviewProfile() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  console.log({ isMobile });
  return isMobile ? (
    <CoachDetailsPreviewProfileMobile />
  ) : (
    <CoachDetailsPreviewProfileDesktop />
  );
}
